import { CustomDialog } from '../../components/CustomDialog';
import { useState } from 'react';
import {
  AutoCompleteController,
  Button,
} from '../../components';
import { useAppDispatch } from '../../storeHook';
import { showAlert } from '../../services/alert';
import {
  useGetFAListQuery,
  useUpdateOrderMutation,
} from '../../services/orders';
import * as yup from 'yup';
import { useFormWithSchema } from '../../utils/functions/yupFormTypescript';
import { TOrderTableProps } from '../../utils/types/orders';

const formSchema = yup.object({
  pinCodeFAMappingId: yup
    .number()
    .required('please select an option'),
});
type TFormData = yup.InferType<typeof formSchema>;

export const ChangeFA: React.FC<{
  data: TOrderTableProps;
}> = ({
  data: {
    enterpriseId,
    id,
    sapOrderId,
    pinCodeFAMappingId,
  },
}) => {
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
    defaultValues: {
      pinCodeFAMappingId,
    },
  });

  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const [updateOrder] = useUpdateOrderMutation();
  const { data: faList } = useGetFAListQuery(enterpriseId);
  const formattedFAList = faList?.map((fa) => ({
    value: fa.id,
    label: `${fa.empName} [${fa.pinCodeFrom} - ${fa.pinCodeTo}] [${fa.plant}]`,
  }));

  const onUpdateOrder = (formData: TFormData) => {
    setOpen(false);
    updateOrder({
      sapOrderId,
      pinCodeFAMappingId: formData.pinCodeFAMappingId,
      id,
    })
      .unwrap()
      .then(() => {
        dispatch(
          showAlert({
            content: 'FA changed Successfully',
          })
        );
      })
      .catch((err) => {
        console.log('error', err);
        // this.utility.handleError(err);
      });
  };

  return (
    <>
      <Button
        onClick={() => setOpen(!open)}
        className="ml-2"
        variant="button--quaternary">
        <div className="text-xs">Change FA</div>
      </Button>
      <CustomDialog
        isForm
        dialogTitle="Change Field Agent"
        open={open}
        setOpen={setOpen}
        onSubmit={handleSubmit(onUpdateOrder)}
        actionText={{ submit: 'Update', cancel: 'Cancel' }}
        maxWidth="sm">
        <AutoCompleteController
          label="Field Agent"
          placeholder="Change Field Agent"
          control={control}
          name="pinCodeFAMappingId"
          options={formattedFAList}
          error={errors?.pinCodeFAMappingId?.message}
          required
        />
      </CustomDialog>
    </>
  );
};
